import { ColumnFilterElementTemplateOptions } from 'primereact/column'
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown'

import { OrderProcessCompletions } from '../../features/selfservice/supplier/data'
import i18n from '../../utils/i18n'
import { OrderProcessBodyTemplate } from './OrderProcessBodyTemplate'

export const OrderProcessFilterTemplate = (
  options: ColumnFilterElementTemplateOptions,
) => {
  if (!options) return null

  const processSteps: OrderProcessCompletions[] = [
    'orderresponse',
    'despatchadvice',
    'invoice',
  ]

  const valueTemplate = (option: any, props: any) => {
    if (option) {
      return OrderProcessBodyTemplate(option)
    }

    return <>{props.placeholder}</>
  }

  const itemTemplate = (option: any) => {
    return OrderProcessBodyTemplate(option)
  }

  return (
    <Dropdown
      value={options.value}
      options={processSteps}
      onChange={(e: DropdownChangeEvent) =>
        options.filterCallback(e.value, options.index)
      }
      valueTemplate={valueTemplate}
      itemTemplate={itemTemplate}
      className="p-column-filter"
      placeholder={i18n.t('common.placeholders.searchProcessCompletion')}
    />
  )
}
